/* eslint-disable @next/next/no-img-element */
// libraries
import Slider from '@mui/material/Slider';
import { motion } from 'framer-motion';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { formatCaracteristicas, formatSelects, formatSelectsTransacao, removerAcentos, toPrice } from '../../../utils/FunctionsGlobals';
import { useAuth } from '../../context/Info';
import DrawerComponent from '../../drawer/DrawerComponent';
import Mocks from './WelcomePieces.mocks';
import styles from './WelcomePieces.module.css';
const Select = dynamic(() => import('react-select'), { ssr: false });

// interface
interface ISelectors {
    allCities: Array<{ label: string; value: string; id_estado: any }>;
    allTypes: any;
    allTransacao: Array<{ label: string; value: string }>;
    allCompany: Array<{ label: string; value: string }>;
    site: any;
    urlBanner: string;
    companyInputActual: any;
    setCompanyInputActual: any;
    setActiveDrawer: any;
    activeDrawer: any;
    origin?: any;
    codsite?: any;
    favorito: Array<number>;
    valores?: any;
    codsite2?: any;
    isMobile1?: Boolean;
    props: any;
    allCards: any;
}

const WelcomePieces: React.FC<ISelectors> = ({
    allCities,
    allTypes,
    allCompany,
    allTransacao,
    site,
    urlBanner,
    companyInputActual,
    setCompanyInputActual,
    setActiveDrawer,
    activeDrawer,
    origin,
    codsite,
    favorito,
    valores,
    codsite2,
    isMobile1,
    props,
    allCards
}) => {
    // constants
    const {
        listCategory,
        setListCategory,
        listEstados,
        setListEstados,
        listCaracteristicas,
        setListCaracteristicas,
        listDatas,
        setListDatas
    } = useAuth();
    const colorPicker = Mocks.customSelectStyles(site?.cor1 == "#ffffff" ? "black" : site?.cor1);
    function valuetext(value: number) {
        return `${value}°C`;
    }
    const minDistance = 500;
    const allOptions = [{label: '1', value: 1},{label: '2', value: 2},{label: '3', value: 3},{label: '4', value: 4},{label: '5 +', value: 5}];
    const [allDistrict, setAllDistrict] = useState([]);
    const [allCitiesAux, setAllCitiesAux] = useState(site?.id == 2177 ? allCities.filter(city => city?.id_estado == 24) : allCities);
    const [searchAdvanced, setSearchAdvanced] = useState(site?.id == "2023" || site?.id == "1667" || site?.id == "2366" || site?.id == "2118" || site?.id == "2148" || site?.id == "278" ? 1 : 0);
    const [citiesActual, setCitiesActual] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
    const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [categoryActual, setCategoryActual] = useState<any>([]);
    const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2177 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
    const [urlTipo, setUrlTipo] = useState<string>("");
    const [urlCaract, setUrlCaract] = useState<string>("");
    const [urlDatas, setUrlDatas] = useState<string>("");
    const [urlDistrict, setUrlDistrict] = useState<string>("");
    const [transacaoActual, setTransacaoActual] = useState<any>(allTransacao[0]);
    const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
    const [banheirosActual, setBanheirosAtual] = useState<any>();
    const [suitesActual, setSuitesAtual] = useState<any>();
    const [vagasActual, setVagasAtual] = useState<any>();
    const [codeActual, setCodeActual] = useState('');
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [buscaAvan, setBuscaAvan] = useState<boolean>(false);

    const newFilter = () => {
        if (transacaoActual?.value) {
            if (transacaoActual.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (transacaoActual.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
        } else {
            if (allTransacao[0]?.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (allTransacao[0]?.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
        }
        if(valores?.precos_venda[0]?.max > 0){
            return valores?.precos_venda[0];
        }else{
            return valores?.precos_locacao[0];
        }
    };
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [value2, setValue2] = React.useState<number[]>([getFiltersPricess?.min , getFiltersPricess?.max]);

    const handleChange2 = (
        event: Event,
        newValue: number | number[],
        activeThumb: number,
      ) => {
        if (!Array.isArray(newValue)) {
          return;
        }
        if (newValue[1] - newValue[0] < minDistance) {
          if (activeThumb === 0) {
            const clamped = Math.min(newValue[0], value2[1] - minDistance);
            setValue2([clamped, clamped + minDistance]);
          } else {
            const clamped = Math.max(newValue[1], minDistance);
            setValue2([clamped - minDistance, clamped]);
          }
        } else {
          setValue2(newValue as number[]);
        }
        setBuscaAvan(true);
      };

    // methods
    const renderPath = () => {
        let newPath = `/imoveis/${transacaoActual?.value.toLowerCase() || allTransacao[0]?.value.toLowerCase() || 'venda'}/${citiesActual?.label.replaceAll("-","002D") || '-'
            }/${urlDistrict.replaceAll("-","002D") || '-'}/${companyActual?.label.replaceAll("-","002D") || '-'}/${urlTipo.replaceAll("-","002D") || '-'
            }${codeActual ? `/${codeActual.replaceAll(" ","%20")}` : ''}${codsite2 != undefined ? '?codsite='+codsite2 : ''}${buscaAvan || site?.id == 2177 ? origin.includes("teste.sobressai.com") ? '&id_estado='+ estadoActual?.value + '&min='+value2[0] + '&max=' + value2[1] + '&dormitorios=' + (dormitoriosActual?.value || 0) + '&banheiros=' + (banheirosActual?.value || 0) + '&suites=' + (suitesActual?.value || 0) + '&vagas=' + (vagasActual?.value || 0) :  '?id_estado='+estadoActual?.value + '&min='+value2[0] + '&max=' + value2[1] + '&data_entrega=' + (urlDatas ? urlDatas : '') + '&categoria=' + (categoryActual?.value || '')+'&dormitorios=' + (dormitoriosActual?.value || 0) + '&banheiros=' + (banheirosActual?.value || 0) + '&suites=' + (suitesActual?.value || 0) + '&vagas=' + (vagasActual?.value || 0) + '&id_caracteristica=' + (urlCaract ? urlCaract : '') : ''}`.replaceAll(' ', '-');
        return removerAcentos(newPath).toLowerCase();
    };
    const onChangeCity = async (txt: any) => {
        if(citiesActual == txt)
            setCitiesActual(null);
        else{
            setCitiesActual(txt);
            const infoDistrict = await district(txt.value, origin, codsite);
            setAllDistrict(formatSelects(infoDistrict?.bairros));
            setDistrictActual([])
        }
    };
    const onChangeDistrict = (txt: any) => {
        setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setDistrictActual(txt);
    };
    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt);
    };
    const onChangeTypes = (txt: any) => {
        setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setTypesActual(txt);
    };
    const onChangeCategory = (txt: any) => {
        if(categoryActual == txt)
            setCategoryActual([]);
        else
        setCategoryActual(txt);

        setBuscaAvan(true);
    };
    const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt)
            setEstadoActual(null);
        else{
            // selecionou um novo estado
            setEstadoActual(txt);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = async () => {
        if(listEstados == 0 && site?.id == 2177){
            const getCondo: any = JSON.parse(localStorage.getItem('listEstados') || '[]');

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = await formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem('listEstados', JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory == 0 && site?.categoria_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCategory1') || '[]');

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = await formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem('listCategory1', JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas == 0 && site?.caracteristicas_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCaracteristicas') || '[]');

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = await formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    localStorage.setItem('listCaracteristicas', JSON.stringify(formatCarac));
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas == 0 && site?.mostrar_data_entrega){
            const getCondo: any = JSON.parse(localStorage.getItem('listDatas') || '[]');

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(getCondo);
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = await formatSelectsTransacao(infoDatas?.datas_entrega);

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    formatDatas.unshift(newItem);
                    setListDatas(formatDatas);
                    localStorage.setItem('formatDatas', JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }

    useEffect(() => {
        if((searchAdvanced || site?.id == 1684 || site?.id == 2146 || site?.id == 1803 || site?.id == 2177) && (site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [searchAdvanced]);

    useEffect(() => {
        if(allCitiesAux?.length == 1){
            onChangeCity(allCitiesAux[0]);
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
            redirectToLink();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const redirectToLink = () => {
        const linkElement = document.getElementById("myLink");
        if (linkElement) {
          linkElement.click();
        }
    };

    useEffect(() => {
        const next = newFilter();
        if(next){
            if (filterPrice.min !== next.min || filterPrice.max !== next.max) {
                setFilterPrice(next);
            }

            if (value2[0] !== next.min || value2[1] !== next.max) {
                setValue2([next.min, next.max]);
            }
        }
    }, [allTransacao, transacaoActual]);

    // renders

    const renderArchives = () => {
        if ((isMobile || isMobile1) && urlBanner != undefined && urlBanner != "" && urlBanner != "undefined" && urlBanner && site?.id != 1235) {
            return (
                <Image
                    className={searchAdvanced ? styles.video_renderOn : styles.video_render}
                    alt="Banner"
                    height={1200}
                    width={600}
                    src={urlBanner.replaceAll('"', "")}
                    priority
                />
            );
        } else {
            if ((isMobile || isMobile1) && site?.id == 1235) {
                return (
                    <video
                        autoPlay
                        muted
                        loop
                        height="100%"
                        width="100%"
                        className={searchAdvanced ? styles.video_renderOn : styles.video_render}
                        src={site?.url_video.replace(".mp4","_b.mp4")}
                        playsInline
                    >
                    <track kind="captions" label="Legenda" src="legenda.vtt"></track>
                    </video>
                );
            }
            return (
                <video
                    autoPlay
                    muted
                    loop
                    height="100%"
                    width="100%"
                    className={searchAdvanced ? styles.video_renderOn : styles.video_render}
                    src={site?.url_video}
                    playsInline
                >
                <track kind="captions" label="Legenda" src="legenda.vtt"></track>
                </video>
            );
        }
    };

    const GetOnlyCityCanoas = () => {
        const GetOnlyType = allCitiesAux.filter((e: any) => {
            return String(e.label)=="Canoas";
        })
        return GetOnlyType[0];
    };
    return (
        <>
            {renderArchives()}
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                menus={props?.menus}
            />
            <div className={styles.header_welcome}>
                <div className={styles.body}>
                    {!searchAdvanced ?
                        <div className={styles.container_adjust_text_header} data-site-id={site?.id}>
                            <div className={styles.container_adjust_text_header}>
                                <span className={styles.adjust_text_header}>
                                    {site?.frase_busca ?
                                    site?.id == '2112' ?
                                    <motion.h1
                                        alt="Título"
                                        className={styles.text_header}
                                        style={{fontSize: '64px', margin: '0px'}}
                                        dangerouslySetInnerHTML={{
                                            __html: site?.frase_busca.toUpperCase(),
                                        }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.2,
                                            duration: 1,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    :
                                    <motion.h1
                                        alt="Título"
                                         className={styles.text_header}
                                        style={site?.id == 2102 ? {fontSize: 36} : site?.id == 1992 ? {fontSize: 38} : site?.id == 2165 || site?.id == 1630 ? {fontWeight: 500} : site?.id == 1730 ? {color: "#eacba6"} : site?.id == '2127' ? {margin: 0} : site?.id == 2126 ? {color: "#ab0303",fontSize: 40} : {}}
                                        dangerouslySetInnerHTML={{
                                            __html: site?.id === 2177
                                              ? `<span style="font-weight:100;">Descubra o Melhor do </span><span style="font-weight:bold;">Litoral Catarinense</span><span style="font-weight:100;"> e da </span><span style="font-weight:bold;">Serra Gaúcha</span>.<br>
                                                 <span style="font-weight:100;">Imóveis exclusivos em </span><span style="font-weight:bold;">Itapema, Gramado e Canela</span><span style="font-weight:100;"> com a </span><span style="font-weight:bold;">confiança da Imobiliária Régis da Silveira</span>.`
                                              : site?.frase_busca,
                                          }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.2,
                                            duration: 1,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    : null}
                                    {site?.frase_busca_2 ?
                                    <motion.h2
                                        alt="Subtitulo"
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.4,
                                            duration: 1,
                                            ease: "easeOut"
                                        }}
                                    className={styles.text_header2} style={site?.id == 1992 ? {fontSize: 25} : site?.id == '2103' ? {fontSize: '24px', fontFamily: 'Roboto'} : site?.id == '2127' ? {fontSize: '26px'} : site?.id == '2348' ? {fontSize: '24px'} : {}}>
                                        {site?.frase_busca_2}</motion.h2>
                                    : null}
                                </span>
                            </div>
                        </div>
                    : null}
                    { site?.id != "1999" ?
                        <motion.div
                            alt="Filtros"
                            className={site?.id == "2057" ? styles.adjust_selects2 : styles.adjust_selects}
                            style={site?.id == "1937" ? {background: "none"} : {background: `${site?.cor1 + 50}` }}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.6,
                                duration: 1,
                                ease: "easeOut"
                            }}
                        >
                            <div className={styles.column}>
                                { site?.id != "1937" ? <>
                                    <div className={site?.transacoes?.length > 1 ? styles.menu : styles.advancedOff} style={site?.id == "1819" ? {width: "33%"}:{}}>
                                        <label htmlFor="react-select-1-input" className={styles.visually_hidden}>Escolha a Transação:</label>
                                        <Select
                                            defaultValue={allTransacao[0]?.value}
                                            options={allTransacao}
                                            className={styles.select}
                                            placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value :"Transação"}
                                            noOptionsMessage={() =>
                                                'Processando'
                                            }
                                            styles={colorPicker}
                                            value={transacaoActual}
                                            onChange={onChangeTransacao}
                                            instanceId={1}
                                            isSearchable={false}
                                        />
                                    </div>
                                    {(site?.id == "1684" || site?.id == "2146" || site?.id == "1803") && site?.categoria_home && listCategory?.length > 0 &&
                                    <div className={styles.menu}>
                                        <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Categoria:</label>
                                        <Select
                                            options={listCategory}
                                            className={styles.select}
                                            placeholder="Categoria"
                                            noOptionsMessage={() =>
                                                'Categoria não encontrada'
                                            }
                                            styles={colorPicker}
                                            onChange={onChangeCategory}
                                            value={categoryActual}
                                            instanceId={3}
                                            isSearchable={isMobile || isMobile1 ? false : true}
                                        />
                                    </div>}
                                    <div className={site?.transacoes?.length > 1 || site?.id == "1684" || site?.id == "1955" || site?.id == "2351" || site?.id == "2177" || site?.id == "1630" || site?.id == "604" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"}:{}}>
                                        <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Escolha o Tipo:</label>
                                        <Select
                                            options={allTypes}
                                            className={styles.select}
                                            isMulti
                                            placeholder={urlTipo ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                                            styles={colorPicker}
                                            closeMenuOnSelect={site?.id == "2091" ? true : false}
                                            controlShouldRenderValue={false}
                                            noOptionsMessage={() =>
                                                'Tipo não encontrado'
                                            }
                                            hideSelectedOptions={false}
                                            tabSelectsValue={false}
                                            value={typesActual}
                                            onChange={onChangeTypes}
                                            closeMenuOnScroll={true}
                                            isSearchable={isMobile || isMobile1 ? false : true}
                                            instanceId={2}
                                        />
                                    </div>
                                    {site?.id == 2177 && listEstados &&
                                        <div className={styles.menu}>
                                            <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Estado:</label>
                                            <Select
                                                options={listEstados}
                                                className={styles.select}
                                                placeholder="Estado"
                                                noOptionsMessage={() =>
                                                    'Estado não encontrado'
                                                }
                                                styles={colorPicker}
                                                onChange={onChangeEstado}
                                                value={estadoActual}
                                                instanceId={113}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>}
                                    {site?.id == "1819" ?
                                        null
                                    :<>
                                        <div className={site?.transacoes?.length > 1 || site?.id == "1684" || site?.id == "2177" || site?.id == "1630" || site?.id == "1955" || site?.id == "2351" || site?.id == "604" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                            <label htmlFor="react-select-3-input" className={styles.visually_hidden}>Escolha a Cidade:</label>
                                            <Select
                                                options={allCitiesAux}
                                                className={styles.select}
                                                placeholder="Cidade"
                                                noOptionsMessage={() =>
                                                    'Cidade não encontrada'
                                                }
                                                styles={colorPicker}
                                                onChange={onChangeCity}
                                                value={!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual}
                                                instanceId={3}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>
                                        <div className={site?.transacoes?.length > 1 || site?.id == "1684" || site?.id == "2177" || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" || site?.id == "604" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                            <label htmlFor="react-select-4-input" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                            <Select
                                                options={allDistrict}
                                                className={styles.select}
                                                placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                controlShouldRenderValue={false}
                                                hideSelectedOptions={false}
                                                tabSelectsValue={false}
                                                noOptionsMessage={() =>
                                                    citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                }
                                                isMulti
                                                styles={colorPicker}
                                                value={districtActual}
                                                onChange={onChangeDistrict}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                                instanceId={4}
                                            />
                                        </div>
                                        { site?.id == "604" || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" ?
                                            <div className={site?.transacoes?.length > 1 || site?.id == "2351" || site?.id == "1684" || site?.id == "1630" || site?.id == "604" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                <Select
                                                    options={allCompany}
                                                    className={styles.select1}
                                                    placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : "Condomínios"}
                                                    styles={colorPicker}
                                                    value={companyActual}
                                                    inputValue={companyInputActual}
                                                    noOptionsMessage={() =>
                                                        allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                                                    }
                                                    instanceId={9}
                                                    onChange={onChangeCompany}
                                                    onInputChange={onInputChangeCompany}
                                                />
                                            </div>
                                        : null }
                                    </>}

                                    <div className={site?.transacoes?.length > 1 || site?.id == "1684" || site?.id == "1955" || site?.id == "2351" || site?.id == "2118" || site?.id == "2177" || site?.id == "1630" || site?.id == "604" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"}:{}}>
                                        <label htmlFor="codigoDoImovel" className={styles.visually_hidden}>Escolha a Referência:</label>
                                        <input
                                            className={styles.input}
                                            placeholder=" Código"
                                            value={codeActual}
                                            onChange={onChangeCode}
                                            id="codigoDoImovel"
                                            type="text"
                                        />
                                    </div>
                                    <div className={searchAdvanced ? styles.advanced : styles.advancedOff}>
                                        {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && site?.categoria_home && listCategory?.length > 0 &&
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Categoria:</label>
                                            <Select
                                                options={listCategory}
                                                className={styles.select}
                                                placeholder="Categoria"
                                                noOptionsMessage={() =>
                                                    'Categoria não encontrada'
                                                }
                                                styles={colorPicker}
                                                onChange={onChangeCategory}
                                                value={categoryActual}
                                                instanceId={3}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>}
                                        {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && site?.caracteristicas_home && listCaracteristicas?.length > 0 &&
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Características:</label>
                                            <Select
                                                options={listCaracteristicas}
                                                className={styles.select}
                                                isMulti
                                                placeholder={urlCaract ? caractActual?.length + " Selecionada (s)" : "Características"}
                                                noOptionsMessage={() =>
                                                    'Característica não encontrada'
                                                }
                                                styles={colorPicker}
                                                closeMenuOnSelect={false}
                                                controlShouldRenderValue={false}
                                                hideSelectedOptions={false}
                                                tabSelectsValue={false}
                                                onChange={onChangeCaracteristicas}
                                                value={caractActual}
                                                closeMenuOnScroll={false}
                                                instanceId={12}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>}
                                        {site?.mostrar_data_entrega && listDatas?.length > 0 &&
                                            <div className={styles.menu2}>
                                                <label htmlFor="react-select-111-input" className={styles.visually_hidden}>Data Entrega:</label>
                                                    <Select
                                                        options={listDatas}
                                                        className={styles.select}
                                                        isMulti
                                                        placeholder={urlDatas ? dataEntregaActual?.length + " Selecionada (s)" : "Datas de entrega"}
                                                        noOptionsMessage={() =>
                                                            'Data de entrega não encontrada'
                                                        }
                                                        styles={colorPicker}
                                                        closeMenuOnSelect={false}
                                                        controlShouldRenderValue={false}
                                                        hideSelectedOptions={false}
                                                        tabSelectsValue={false}
                                                        onChange={onChangeDataEntrega}
                                                        value={dataEntregaActual}
                                                        closeMenuOnScroll={false}
                                                        instanceId={12}
                                                        isSearchable={isMobile || isMobile1 ? false : true}
                                                    />
                                            </div>
                                        }
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-5-input" className={styles.visually_hidden}>Dormitórios:</label>
                                            <Select
                                                options={allOptions}
                                                className={styles.select}
                                                placeholder={dormitoriosActual?.value == 1 ? "1 Dormitório" : (dormitoriosActual?.label || "") + " Dormitórios"}
                                                styles={colorPicker}
                                                value={dormitoriosActual}
                                                onChange={onChangeDormitorios}
                                                isSearchable={false}
                                                instanceId={5}
                                                controlShouldRenderValue={false}
                                            />
                                        </div>
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-6-input" className={styles.visually_hidden}>Banheiros:</label>
                                            <Select
                                                options={allOptions}
                                                className={styles.select}
                                                placeholder={banheirosActual?.value == 1 ? "1 Banheiro" : (banheirosActual?.label || "") + " Banheiros"}
                                                styles={colorPicker}
                                                value={banheirosActual}
                                                onChange={onChangeBanheiros}
                                                isSearchable={false}
                                                instanceId={6}
                                                controlShouldRenderValue={false}
                                            />
                                        </div>
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-7-input" className={styles.visually_hidden}>Suítes:</label>
                                            <Select
                                                options={allOptions}
                                                className={styles.select}
                                                placeholder={suitesActual?.value == 1 ? "1 Suite" : (suitesActual?.label || "") + " Suites"}
                                                styles={colorPicker}
                                                value={suitesActual}
                                                onChange={onChangeSuites}
                                                instanceId={7}
                                                isSearchable={false}
                                                controlShouldRenderValue={false}
                                            />
                                        </div>
                                        <div className={styles.menu2}>
                                            <label htmlFor="react-select-8-input" className={styles.visually_hidden}>Vagas:</label>
                                            <Select
                                                options={allOptions}
                                                className={styles.select}
                                                placeholder={vagasActual?.value == 1 ? "1 Vaga" : (vagasActual?.label || "") + " Vagas"}
                                                styles={colorPicker}
                                                value={vagasActual}
                                                onChange={onChangeVagas}
                                                instanceId={8}
                                                isSearchable={false}
                                                controlShouldRenderValue={false}
                                            />
                                        </div>
                                        { site?.exibir_empreendimento && site?.id != "604" && site?.id != "1630" && site?.id != "1955" && site?.id != "2351" ?
                                            <div className={styles.pricefilter}>
                                                <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                <Select
                                                    options={allCompany}
                                                    className={styles.select1}
                                                    placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : "Condomínios"}
                                                    styles={colorPicker}
                                                    value={companyActual}
                                                    inputValue={companyInputActual}
                                                    noOptionsMessage={() =>
                                                        allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                                                    }
                                                    instanceId={9}
                                                    onChange={onChangeCompany}
                                                    onInputChange={onInputChangeCompany}
                                                />
                                            </div>
                                        : null }
                                        <div className={styles.pricefilter} style={{padding: "0px 0px 0px 5%"}}>
                                            <div className={styles.adjust_select_price}>
                                                <div className={styles.title_select}>
                                                    PREÇOS
                                                </div>
                                                <div className={styles.adjust_prices}>
                                                    <div className={styles.price}>
                                                        {`${site?.moeda_tipo} ${toPrice(Number(value2[0]),2
                                                        )}`}
                                                    </div>
                                                    <div className={styles.price}>
                                                        {`${site?.moeda_tipo} ${toPrice(
                                                            Number(value2[1]),2
                                                        )}`}
                                                    </div>
                                                </div>
                                                <Slider
                                                    getAriaLabel={() => 'Minimum distance shift'}
                                                    value={value2}
                                                    onChange={handleChange2}
                                                    valueLabelDisplay="auto"
                                                    min={filterPrice?.min}
                                                    max={filterPrice?.max}
                                                    step={transacaoActual?.value == "Aluguel" ? 100 : 10000}
                                                    style={{
                                                        color: `${'rgb(255, 255, 255)'}`,
                                                    }}
                                                    getAriaValueText={valuetext}
                                                    disableSwap
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null}
                                <div className={styles.menuBottom}>
                                    <Link
                                        href={site?.id != "1937" ? renderPath() : `https://api.whatsapp.com/send?phone=${(
                                        site?.Dados?.tel1 ||
                                        site?.Dados?.tel2 ||
                                        site?.Dados?.tel3 ||
                                        site?.Dados?.tel4
                                        )?.replace(/\D/g, '')}&text=Olá, estou no site da ${site?.titulo} Visitando a página https://${site?.site} pode me ajudar?`}
                                        id="myLink"
                                        title={`Buscar ${typesActual[0] ? typesActual[0]?.label : 'imóveis'}${districtActual[0] ? ' em '+ districtActual[0]?.label : ''}${citiesActual?.label ? ' - '+ citiesActual?.label : ''}${codeActual ? ' - Imóvel código: '+ codeActual : ''}`}
                                        className={site?.id == "1937" ? styles.btn_leila : styles.btn}
                                        style={site?.id == 2231 ?
                                            {
                                                background: `${site?.cor2 || 'rgb(30 30 30)'}`,
                                                border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                                color: site?.id == "2126" ? "white" : site?.cor4,
                                                borderRadius: 10
                                            }
                                            : {
                                            background: `${site?.cor2 || 'rgb(30 30 30)'}`,
                                            border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                            color: site?.id == "2126" ? "white" : site?.cor4
                                            }}
                                        >
                                        {site?.id != "1937" ? "Buscar" : "Fale com a Leila"}
                                    </Link>
                                </div>
                            </div>
                        </motion.div>
                    : null }
                        <motion.div
                            alt="Avançado"
                            className={styles.buttonAdvanced}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 0.8,
                                duration: 1,
                                ease: "easeOut"
                            }}
                        >
                        {site?.id != "1937" && site?.id != "1999" ?
                            searchAdvanced ?
                                <div onClick={() => setSearchAdvanced(0)}>
                                    <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                                        <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                                    </svg>
                                    <i style={{margin: "5px"}}>
                                        Simples
                                    </i>
                                </div> :
                                <div onClick={() => setSearchAdvanced(1)}>
                                    <svg
                                        viewBox="0 0 18 18"
                                        height="1rem"
                                        width="1rem"
                                        aria-hidden="true"
                                        style={{ fill: 'white' }}
                                    >
                                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                                        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                                    </svg>
                                    <i style={{margin: "5px"}}>
                                        Avançado
                                    </i>

                                </div>
                        : null}
                    </motion.div>
                    { allCards?.length > 0 ?
                        <motion.ul
                            alt="Busca rápida"
                            className={styles.allCards}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 1,
                                duration: 1,
                                ease: "easeOut"
                            }}
                        >
                            {allCards.map((card: any, index: number) => {
                                return (
                                    <li className={styles.allCardsLi} key={index}>
                                        <Link prefetch={false} href={removerAcentos(card?.url).toLowerCase()} passHref>
                                            <div className={styles.card_busca} title={`Busca personalizada por imóvies: ${card?.nome}`}>{card?.nome}</div>
                                        </Link>
                                    </li>
                                );
                            })}
                        </motion.ul>
                    : null }
                </div>
            </div>
        </>
    );
};

export default WelcomePieces;
